import React from 'react';

import { experience } from './payload';
import { ExperienceSection as SPEExperienceSection } from '../../spe-ne';

export const OurExperienceSection = () => (
  <SPEExperienceSection
    desc="We are cloud enthusiasts with expertise in building and integrating cloud solutions across private, public and hybrid cloud environments. We design our solutions with time-to-market, cost optimization and scalability requirements in mind. We also ensure seamless migration."
    payload={experience}
    id="spe-cloud-experience"
  />
);
